import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageContainer from '../../PageContainer';
import { EventInvite } from './EventInvite';

export const EventInvitePage = ({ history }: RouteComponentProps) => {
  return (
    <PageContainer history={history}>
      <EventInvite />
    </PageContainer>
  );
};
